import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Device } from "src/app/classes/device";
import { DashboardService } from "../dashboard.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MustMatch } from "src/app/data-service/must-match.validator";
import { MatInput } from "@angular/material";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-add-third-party-api",
  templateUrl: "./add-third-party-api.component.html",
  styleUrls: ["./add-third-party-api.component.scss"],
})
export class AddThirdPartyApiComponent implements OnInit {
  private ResponseVerifiedAddDevice$: Subject<any> = new Subject();
  private ResponseVerifiedUpdateDevice$: Subject<any> = new Subject();
  private ResponseVerifiedGetDeviceInfo$: Subject<any> = new Subject();
  private ResponseVerifiedGetAllEpcUser$: Subject<any> = new Subject();
  @ViewChild("input1", { read: MatInput, static: false }) input1: MatInput;
  @ViewChild("input3", { read: MatInput, static: false }) input3: MatInput;

  public uploadFlagSpinner: any;
  deviceInfo = new Device();
  addThridPartyForm: FormGroup;
  message: string;
  dev_name: any;
  isEditing: any;
  deviceId: any;
  editDeviceObject: any = {};
  dataObject: any = [];
  organisationname: string;
  server_ip: any;
  subscriptionend: any;
  user_id: any;
  editCompany_Name: any;
  editMake_Id: any;
  editMax_Param_Count: any;
  editInverter_Capacity: any;
  public allusers: any;
  role: any;
  roleName: string;
  search: any = "";
  page = 1;
  limit: any = 0;
  offset: any = 0;
  srcString: any;
  subscriptionstart: any;
  getEpcObj: any;
  flag: any;
  pipe = new DatePipe("en-US");

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private dashbord: DashboardService,
    private toastr: ToastrService
  ) {
    this.route.queryParams.subscribe((params) => {
      if (params.id) {
        this.isEditing = true;
        this.deviceId = params.id;
      }
    });
    this.role = localStorage.role;
    if (this.role == "1") {
      this.roleName = "admin";
    } else if (this.role == "2") {
      this.roleName = "epc";
    } else if (this.role == "5") {
      this.roleName = "slave_admin";
    }
  }

  ngOnInit() {
    this.addThridPartyForm = this.fb.group({
      // We can set default values by passing in the corresponding value or leave blank if we wish to not set the value. For our example, we’ll default the gender to female.
      organizationName: [
        "",
        [
          Validators.required,
          Validators.pattern("^[#.0-9a-zA-Zs,-_@`~!%^&*()_+-=?<>${}[]|/]+$"),
        ],
      ], //[a-zA-Z0-9][a-zA-Z0-9 ]+
      server_ip: ["", [Validators.required, Validators.maxLength(15)]],
      subscriptionstart: ["", [Validators.required]],
      subscriptionend: ["", [Validators.required]],
      userId: ["", [Validators.required]],
    });

    if (this.isEditing == true) {
      this.getInfoByDeviceId();
    }

    if (this.roleName == "admin" || this.roleName == "slave_admin") {
      this.getAllUsers();
    }
  }
  get f() {
    return this.addThridPartyForm.controls;
  }

  add_device() {
    var userInfo = {
      login_id: this.addThridPartyForm.controls["userId"].value,
      user_id: this.addThridPartyForm.controls["userId"].value,
      server_ip: this.addThridPartyForm.controls["server_ip"].value,
      organisationname:
        this.addThridPartyForm.controls["organizationName"].value,
      subscriptionstart: this.pipe.transform(
        this.addThridPartyForm.controls["subscriptionstart"].value,
        "yyyy-MM-dd"
      ),
      subscriptionend: this.pipe.transform(
        this.addThridPartyForm.controls["subscriptionend"].value,
        "yyyy-MM-dd"
      ),
    };

    this.dashbord
      .saveThirdParty(userInfo)
      .pipe(takeUntil(this.ResponseVerifiedAddDevice$))
      .subscribe(
        (data) => {
          if (data.status === true || data.status === "true") {
            this.toastr.success(data.message);
            this.router.navigate(["/inject-solar/third-party-user"]);
          } else if (!data.status) {
            if (data.message == "Unauthorised or Login Time-out") {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        (err) => {
          return console.log(err);
        }
      );
  }

  update_device() {
    var userInfo = {
      login_id: this.addThridPartyForm.controls["userId"].value,
      user_id: this.addThridPartyForm.controls["userId"].value,
      server_ip: this.addThridPartyForm.controls["server_ip"].value,
      organisationname:
        this.addThridPartyForm.controls["organizationName"].value,
      subscriptionstart: this.pipe.transform(
        this.addThridPartyForm.controls["subscriptionstart"].value,
        "yyyy-MM-dd"
      ),
      subscriptionend: this.pipe.transform(
        this.addThridPartyForm.controls["subscriptionend"].value,
        "yyyy-MM-dd"
      ),
    };
    this.dashbord
      .updateThirdParty(userInfo)
      .pipe(takeUntil(this.ResponseVerifiedUpdateDevice$))
      .subscribe(
        (data) => {
          if (data.status === true || data.status === "true") {
            this.router.navigate(["/inject-solar/third-party-user"]);
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == "Unauthorised or Login Time-out") {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        (err) => {
          return console.log(err);
        }
      );
  }

  getInfoByDeviceId() {
    this.editDeviceObject = {
      id: this.deviceId,
    };
    this.dashbord
      .getUserInfoById(this.editDeviceObject)
      .pipe(takeUntil(this.ResponseVerifiedGetDeviceInfo$))
      .subscribe(
        async (data) => {
          if (data.status) {
            this.editDeviceObject = {};
            this.flag = data.flag;
            this.dataObject = data.resultObject;
            this.organisationname = data.resultObject.organisationname;
            this.server_ip = this.dataObject.server_ip;
            this.subscriptionstart = this.dataObject.subscriptionstart;
            this.subscriptionend = this.dataObject.subscriptionend;
            this.user_id = this.dataObject.user_id;
          } else if (!data.status) {
            if (data.message == "Unauthorised or Login Time-out") {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
          this.addThridPartyForm.get("server_ip").setValue(this.server_ip);
          this.addThridPartyForm.get("organizationName").setValue(this.organisationname);
          this.addThridPartyForm.get("userId").setValue(this.user_id);
          // this.addThridPartyForm.get('company_name').setValue(this.editCompany_Name);
          this.addThridPartyForm
            .get("subscriptionstart")
            .setValue(new Date(this.subscriptionstart));
          this.addThridPartyForm.get("subscriptionend").setValue(new Date(this.subscriptionend));
        },
        (err) => {
          return console.error(err);
        }
      );
  }

  onReset() {
    this.addThridPartyForm.reset();
  }

  // Select DropDown of Epc user List for admin add device
  onEpcChange(value: any) {}

  // get alladmin epc user list
  getAllUsers() {
    this.dashbord.getAllUsers({}).subscribe(
      async (data) => {
        if (data.status) {
          this.allusers = data.resultObject.sort(
            (a: { name: string }, b: { name: any }) =>
              a.name.localeCompare(b.name)
          );
          // this.allusers = data.resultObject;
        } else if (!data.status) {
          if (data.message == "Unauthorised or Login Time-out") {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(data.message);
          }
        }
      },
      (err) => {
        return console.error(err);
      }
    );
  }

  ngOnDestroy() {
    this.ResponseVerifiedGetAllEpcUser$.next();
    this.ResponseVerifiedGetAllEpcUser$.complete();

    this.ResponseVerifiedGetDeviceInfo$.next();
    this.ResponseVerifiedGetDeviceInfo$.complete();

    this.ResponseVerifiedUpdateDevice$.next();
    this.ResponseVerifiedUpdateDevice$.complete();

    this.ResponseVerifiedAddDevice$.next();
    this.ResponseVerifiedAddDevice$.complete();
  }
}
